import { jsx } from 'react/jsx-runtime';
import { useCallback, useMemo } from 'react';
import { RadioGroupContext } from './context.es.js';

/**
 * Radio Group Provider.
 */ const RadioGroupProvider = (props)=>{
    const { children, ...rest } = props;
    // Is checked helper.
    const isChecked = useCallback((value)=>rest.value === value, [
        rest.value
    ]);
    // Memoized provider value.
    const value = useMemo(()=>({
            ...rest,
            isChecked
        }), [
        rest,
        isChecked
    ]);
    return jsx(RadioGroupContext.Provider, {
        value: value,
        children: children
    });
};

export { RadioGroupProvider };
//# sourceMappingURL=provider.es.js.map
